// extracted by mini-css-extract-plugin
export default {"layout":"Banner_layout__SlcuM","bannerImg":"Banner_bannerImg__WR5de","bannerText":"Banner_bannerText__OQYHX"};